import { render } from "./orderDialog.vue?vue&type=template&id=2c381dc3"
import script from "./orderDialog.vue?vue&type=script&lang=js"
export * from "./orderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__